import {AppDispatch, RootState} from "./store";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

// Use throughout the app instead of plain 'useDispatch' and 'useSelector';
// For useSelector, it saves you the need to type (state: RootState) every time.
// For useDispatch, includes thunks middleware types.
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;